import {
    ImprovementCategoryDto,
    ImprovementGroupDto,
    Mi2DatesResult,
    PerformanceClassDto,
    PopulationGroupImprovementGroupDto,
} from '../core';
import { PopulationGroupDialogData } from '../population-group-dialog';
import { SortOptions } from '../table';
import { TrendDialogData } from '../trend-dialog';

import { FilterItemView } from './model/filter-item-view.model';
import { PerformerItemView } from './model/performer-item-view.model';

export interface MainState {
    pending: {
        reload?: boolean;
        showTrend?: boolean;
    };

    categories?: ImprovementCategoryDto[];
    noScoreCategory?: ImprovementCategoryDto;
    dates?: Mi2DatesResult;
    rows?: PerformerItemView[];
    sortOptions?: SortOptions;
    filteredRows?: PerformerItemView[];
    currentPerformanceClassFilterItems?: Array<
        FilterItemView<PerformanceClassDto>
    >;
    previousPerformanceClassFilterItems?: Array<
        FilterItemView<PerformanceClassDto>
    >;
    improvementGroupFilterItems?: Array<FilterItemView<ImprovementGroupDto>>;
    populationGroupImprovementGroups?: PopulationGroupImprovementGroupDto[];

    populationGroupDialogData?: PopulationGroupDialogData;
    trendDialogData?: TrendDialogData;
}

export const defaultState = (): MainState => ({
    pending: {},
});
